export default __webpack_public_path__ + "static/media/2019_image.11913ee4.png";